window.addEventListener('load', () => {
    let subscribeForm = document.getElementById('mailingListForm');
    let buddhaSanctuaryPage = document.querySelector('.location-buddha-sanctuary');
    let innerSanctuaryPage = document.querySelector('.location-inner-sanctuary');
    let lifeSanctuaryPage = document.querySelector('.location-life-sanctuary');

    if (buddhaSanctuaryPage) {
        Cookies.set('locationVisitedBuddhaSanctuary', 'true', { expires: 7 });
    }

    if (innerSanctuaryPage) {
        Cookies.set('locationVisitedInnerSanctuary', 'true', { expires: 7 });
    }

    if (lifeSanctuaryPage) {
        Cookies.set('locationVisitedLifeSanctuary', 'true', { expires: 7 });
    }

    if (subscribeForm) {
        let locationInnerSanctuaryInput = subscribeForm.querySelector('input[name="vN6dq36y7"]')
        let locationBuddhaSanctuaryInput = subscribeForm.querySelector('input[name="vN6dq3PrG"]')
        // let locationLifeSanctuaryInput = subscribeForm.querySelector('input[name="TBD"]')

        if (locationBuddhaSanctuaryInput && (Cookies.get('locationVisitedBuddhaSanctuary'))) {
            locationBuddhaSanctuaryInput.checked = true;
        }

        if (locationInnerSanctuaryInput && Cookies.get('locationVisitedInnerSanctuary')) {
            locationInnerSanctuaryInput.checked = true;
        }

        // if (locationLifeSanctuaryInput && Cookies.get('locationVisitedLifeSanctuary')) {
        //     locationLifeSanctuaryInput.checked = true;
        // }
    }
});
